import { useEffect, useState } from 'react';
import { CaretDown, Check, Robot } from '@phosphor-icons/react';
import { CURATED, useModelChoice } from '@/lib/model';

export default function ModelPicker() {
  const [choice, choose] = useModelChoice();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const close = (e) => { if (!e.target.closest('[data-model-picker]')) setOpen(false); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  const current = CURATED.find(c => c.provider === choice.provider && c.model === choice.model)
                  || { label: `${choice.provider} · ${choice.model}`, tag: 'custom' };

  return (
    <div className="relative" data-model-picker data-testid="model-picker">
      <button
        onClick={() => setOpen(o => !o)}
        className="inline-flex items-center gap-2 border border-zinc-800 hover:border-zinc-600 bg-zinc-950 px-3 py-2 text-[11px] uppercase tracking-[0.18em] text-zinc-300"
        data-testid="model-picker-btn"
      >
        <Robot weight="bold" className="h-3.5 w-3.5 text-emerald-400" />
        <span className="hidden sm:inline max-w-[140px] truncate">{current.label}</span>
        <CaretDown className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-72 border border-zinc-800 bg-zinc-950 shadow-2xl z-40" data-testid="model-picker-menu">
          <div className="label-mini px-3 py-2 border-b border-zinc-800">choose analyst · saved on this device</div>
          <ul className="max-h-80 overflow-y-auto">
            {CURATED.map(c => {
              const active = c.provider === choice.provider && c.model === choice.model;
              return (
                <li key={c.provider + c.model}>
                  <button
                    onClick={() => { choose(c.provider, c.model); setOpen(false); }}
                    className={`w-full text-left flex items-start gap-2 px-3 py-2.5 hover:bg-zinc-900 transition-colors ${active ? 'bg-emerald-500/5' : ''}`}
                  >
                    <span className={`mt-1 h-2 w-2 rounded-full shrink-0 ${active ? 'bg-emerald-400' : 'bg-zinc-700'}`} />
                    <span className="flex-1 min-w-0">
                      <span className="block text-xs font-bold text-zinc-100 font-sans">{c.label}</span>
                      <span className="block text-[10px] text-zinc-500 uppercase tracking-[0.18em]">{c.provider} · {c.tag}</span>
                    </span>
                    {active && <Check weight="bold" className="h-3.5 w-3.5 text-emerald-400" />}
                  </button>
                </li>
              );
            })}
          </ul>
          <div className="border-t border-zinc-800 p-3 text-[10px] text-zinc-500 leading-relaxed">
            Same guardian brain. Just pick the AI you trust. Choice is local to this device.
          </div>
        </div>
      )}
    </div>
  );
}
